"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/bid/message");
exports.initialState = {
    status: 'STANDBY',
    attachmentsStatus: 'STANDBY',
    saveStatus: 'STANDBY',
    prepareStatus: 'STANDBY',
    from: '',
    to: '',
    subject: '',
    message: '',
    attachments: [],
    removedAttachemnts: [],
    errors: fp.option.none
};
const statusLens = monocle.Lens.fromProp('status');
const errorsLens = monocle.Lens.fromProp('errors');
const saveStatusLens = monocle.Lens.fromProp('saveStatus');
const attachmentsLens = monocle.Lens.fromProp('attachments');
const removedAttachemnts = monocle.Lens.fromProp('removedAttachemnts');
const prepareStatusLens = monocle.Lens.fromProp('prepareStatus');
const createdFolderLens = monocle.Lens.fromProp('createdFolder');
const attachmentsStatusLens = monocle.Lens.fromProp('attachmentsStatus');
const updateField = (field) => monocle.Lens.fromProp(field);
exports.methods = {};
exports.methods[ActionTypes.FETCH_REQUEST] = (state, action) => statusLens.set('FETCHING')(state);
exports.methods[ActionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(updateField('from').set(action.payload.from.email), updateField('to').set(action.payload.to), updateField('subject').set(action.payload.subject), updateField('message').set(action.payload.message), statusLens.set('FETCHED'))(state);
exports.methods[ActionTypes.FETCH_FAILED] = (state, action) => statusLens.set('FAILED')(state);
exports.methods[ActionTypes.SET_STANDBY] = (state, action) => saveStatusLens.set('STANDBY')(state);
exports.methods[ActionTypes.SEND_REQUEST] = (state, action) => fp.function.compose(errorsLens.set(fp.option.none), saveStatusLens.set('STANDBY'))(state);
exports.methods[ActionTypes.SEND_SUCCESS] = (state, action) => saveStatusLens.set('FETCHED')(state);
exports.methods[ActionTypes.SEND_VALIDATION_SUCCESS] = (state, action) => saveStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.SEND_VALIDATION_FAILED] = (state, action) => fp.function.compose(errorsLens.set(fp.option.some(action.payload.reduce((rv, x) => {
    ;
    (rv[x.key] = rv[x.key] || []).push(x.value);
    return rv;
}, {}))), saveStatusLens.set('STANDBY'))(state);
exports.methods[ActionTypes.SEND_FAILED] = (state, action) => saveStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.UPDATE_FIELD] = (state, action) => updateField(action.payload.field).set(action.payload.value)(state);
exports.methods[ActionTypes.FETCH_PENDING_FILES_REQUEST] = (state, action) => attachmentsStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.FETCH_PENDING_FILES_SUCCESS] = (state, action) => fp.function.compose(updateField('attachments').set(action.payload), attachmentsStatusLens.set('FETCHED'))(state);
exports.methods[ActionTypes.FETCH_PENDING_FILES_FAILED] = (state, action) => attachmentsStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.FETCH_FILES_REQUEST] = (state, action) => attachmentsStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.FETCH_FILES_SUCCESS] = (state, action) => fp.function.compose(attachmentsLens.set(action.payload), attachmentsStatusLens.set('FETCHED'))(state);
exports.methods[ActionTypes.FETCH_FILES_FAILED] = (state, action) => attachmentsStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.PREPARE_UPLOAD_REQUEST] = (state) => prepareStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.PREPARE_UPLOAD_SUCCESS] = (state, action) => fp.function.compose(createdFolderLens.set(action.payload.createdFolder), prepareStatusLens.set('FETCHED'))(state);
exports.methods[ActionTypes.PREPARE_UPLOAD_FAILED] = (state) => prepareStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.REMOVE_FILES] = (state, action) => removedAttachemnts.modify((files) => {
    const remove = action.payload.filter((x) => files.findIndex((f) => f.id === x.id) === -1);
    return files.concat(remove);
})(state);
exports.methods[ActionTypes.CLEAR] = (state, action) => (Object.assign({}, exports.initialState));
//# sourceMappingURL=message.js.map